export const PROMO_STATUS_MESSAGES = {
  valid: 'Code promo applique.',
  invalid: 'Code promo invalide.',
  inactive: 'Ce code promo est desactive.',
  not_started: "Ce code promo n'est pas encore disponible.",
  expired: 'Ce code promo a expire.',
  non_applicable: "Ce code promo ne s'applique pas a cette operation.",
  already_used: 'Vous avez deja utilise ce code promo.',
  usage_cap_reached: "Ce code promo a atteint son plafond d'utilisation.",
  out_of_scope: "Ce code promo n'est pas disponible pour votre zone.",
  PROMO_INVALID: 'Code promo invalide.',
  PROMO_CODE_ALREADY_EXISTS: 'Ce code promo existe deja.',
  PROMO_DATE_RANGE_INVALID: 'La periode de validite est invalide.',
  PROMO_DISCOUNT_VALUE_INVALID: 'La valeur de reduction est invalide.',
  PROMO_DELIVERY_NOT_EDITABLE: "Cette livraison ne peut plus etre modifiee.",
  PROMO_LOCKED_AFTER_PAYMENT_SUBMISSION: 'Le code promo ne peut plus etre modifie apres soumission du paiement.',
};

export const normalizePromoCodeInput = (value) => String(value || '').trim().toUpperCase();

const toAmount = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
};

export const getPromoFeedbackMessage = (statusOrDetail, fallback = 'Impossible d appliquer ce code promo.') => {
  const normalized = String(statusOrDetail || '').trim();
  if (!normalized) {
    return fallback;
  }
  return PROMO_STATUS_MESSAGES[normalized] || fallback;
};

export const getPricingSummary = (record, { fallbackAmount = 0, fallbackCurrency = 'FCFA' } = {}) => {
  const source = record?.pricing_summary || record || {};
  const amountAfter = toAmount(
    source.amount_after_discount ?? source.amount_after ?? source.cost ?? source.amount ?? fallbackAmount
  );
  const amountBefore = toAmount(
    source.amount_before_discount ?? source.amount_before ?? (amountAfter + toAmount(source.discount_amount))
  );
  const discountAmount = Math.max(0, toAmount(source.discount_amount ?? source.total_discount_amount));
  const referralDiscountAmount = Math.max(0, toAmount(source.referral_discount_amount));
  const promoDiscountAmount = Math.max(
    0,
    toAmount(
      source.promo_discount_amount ?? Math.max(0, discountAmount - referralDiscountAmount)
    )
  );

  return {
    amountBefore,
    discountAmount,
    totalDiscountAmount: discountAmount,
    referralDiscountAmount,
    referralDiscountPercent: toAmount(source.referral_discount_percent),
    referralDiscountApplied: Boolean(source.referral_discount_applied || referralDiscountAmount > 0),
    referralAffiliateType: source.referral_discount_affiliate_type || null,
    promoDiscountAmount,
    amountAfter,
    commissionBaseAmount: toAmount(source.commission_base_amount ?? amountAfter),
    currency: source.currency || fallbackCurrency,
    hasDiscount: discountAmount > 0,
    hasReferralDiscount: referralDiscountAmount > 0,
    hasPromoDiscount: promoDiscountAmount > 0,
    promoCode: source.promo_code || null,
    promoLabel: source.promo_label || source.label || source.promoCode || null,
    stackingPolicy: source.stacking_policy || source.promo_stacking_policy || null,
  };
};

export const buildDeliveryPromoQuote = (formData, overrides = {}) => ({
  pickup_address: formData.pickup_address,
  pickup_city: formData.pickup_city,
  delivery_address: formData.client_address,
  delivery_city: formData.client_city,
  weight: overrides.weight ?? (formData.weight ? Number(formData.weight) : undefined),
  service_tier: formData.service_tier || 'standard',
  is_insured: Boolean(formData.is_insured),
  insured_value: overrides.insured_value ?? (formData.is_insured && formData.insured_value ? Number(formData.insured_value) : undefined),
});
